import { DEFAULT_MODE, makeThemeColor, PRIMARY, SECONDARY } from '@tornado-rdk/theme';
import { FULL_HD, HD } from '@bedrock-rdk/constants';
import { getFont, FONT } from '@tornado-rdk/typography';
import { makeDefaultStylingContext } from '../../utils/style';
import { TRANSPARENT } from '../../utils/colors';
import { middle } from '../../utils/sizes';

export const defaultContext = makeDefaultStylingContext();

export const colors = {
  text: makeThemeColor(PRIMARY),
  circle: makeThemeColor(SECONDARY),
};

export const CIRCLE_SIZE = {
  [HD]: 48,
  [FULL_HD]: 56,
};

export const CIRCLE_MARGIN_RIGHT = {
  [HD]: 24,
  [FULL_HD]: 40,
};

export const getInitialStyle = ({ screenSize = FULL_HD, colorMode = DEFAULT_MODE } = defaultContext) => {
  const numberFont = getFont(FONT.OTTAWA_3, screenSize);
  const textFont = getFont(FONT.OTTAWA_1, screenSize);
  const circleSize = CIRCLE_SIZE[screenSize];

  return {
    h: circleSize,
    Circle: {
      w: circleSize,
      h: circleSize,
      y: middle,
      mountY: 0.5,
      rect: true,
      shader: {
        fillColor: TRANSPARENT,
        strokeColor: colors.circle[colorMode],
        stroke: 4,
        radius: Math.round(circleSize / 2),
      },
    },
    DigitContainer: {
      w: circleSize,
      h: circleSize,
      y: middle,
      mountY: 0.5,
      Digit: {
        x: middle,
        y: middle,
        mount: 0.5,
        text: {
          ...numberFont,
          textColor: colors.text[colorMode],
          verticalAlign: 'middle',
          textAlign: 'center',
        },
      },
    },
    Title: {
      x: circleSize + CIRCLE_MARGIN_RIGHT[screenSize],
      y: middle,
      mountY: 0.5,
      text: {
        ...textFont,
        textColor: colors.text[colorMode],
        maxLines: 3,
        maxLinesSuffix: '...',
        verticalAlign: 'middle',
      },
    },
  };
};
